import Grid from "@mui/material/Grid";
import Servicemenu from "../../features/serviceMenu/ServiceMenu";
import BreakingNews from "../components/breakingNews/BreakingNews";
import useOnlineStatus from "../../common/utils/OnlineStatusProvider";
import Offline from "./Offline";

const Home = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return (
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12} >
          <Servicemenu />
          <BreakingNews />
        </Grid>

      </Grid>
    );
  } else {
    return <Offline />;
  }
};

export default Home;